(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  function addBusinessDays(d, n){ var r = new Date(d); var added = 0; while(added < n){ r.setDate(r.getDate() + 1); var w = r.getDay(); if(w !== 0 && w !== 6) added++; } return r; }
  function fmt(d){ var dd = ('0' + d.getDate()).slice(-2), mm = ('0' + (d.getMonth() + 1)).slice(-2), yy = String(d.getFullYear()).slice(-2); return dd + '/' + mm + '/' + yy; }
  document.querySelectorAll('[data-v2-ship]').forEach(function(box){
    var now = new Date();
    var start = new Date(now); var w = start.getDay();
    if(w === 6) start.setDate(start.getDate() + 2); else if(w === 0) start.setDate(start.getDate() + 1);
    var shipD = addBusinessDays(start, +box.dataset.ship || 2);
    var minD = addBusinessDays(start, +box.dataset.min || 8);
    var maxD = addBusinessDays(start, +box.dataset.max || 15);
    var d1 = box.querySelector('[data-v2-d1]'), d2 = box.querySelector('[data-v2-d2]'), d3 = box.querySelector('[data-v2-d3]'), rg = box.querySelector('[data-v2-range]');
    if(d1) d1.textContent = fmt(now);
    if(d2) d2.textContent = fmt(shipD);
    if(d3) d3.textContent = fmt(minD) + ' \u2013 ' + fmt(maxD);
    if(rg) rg.textContent = fmt(minD) + ' \u2013 ' + fmt(maxD);
  });
  document.querySelectorAll('[data-bt-product]').forEach(function(root){
    var dataEl = root.querySelector('[data-bt-variants]');
    var gal = root.querySelector('.bt-gal');
    var form = root.querySelector('form[data-bt-form]');
    var qty = root.querySelector('input[name="quantity"]');
    root.querySelectorAll('[data-v2-qty]').forEach(function(b){
      b.addEventListener('click', function(){ if(!qty) return; var v = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.v2Qty, 10)); qty.value = v; });
    });
    var now = root.querySelector('[data-v2-buynow]');
    if(now && form){
      now.addEventListener('click', function(){
        var err = root.querySelector('[data-bt-error]');
        now.setAttribute('aria-busy', 'true'); now.disabled = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
          .then(function(r){ return r.json().then(function(j){ if(!r.ok) throw j; return j; }); })
          .then(function(){ window.location.href = '/checkout'; })
          .catch(function(e){ if(err){ err.textContent = (e && e.description) ? e.description : (root.dataset.error || ''); err.hidden = false; } now.removeAttribute('aria-busy'); now.disabled = false; });
      });
      var addBtn = form.querySelector('[data-bt-add]');
      if(addBtn){ new MutationObserver(function(){ now.disabled = addBtn.disabled; }).observe(addBtn, { attributes: true, attributeFilter: ['disabled'] }); }
    }
    if(!dataEl || !gal) return;
    var data = JSON.parse(dataEl.textContent);
    var fieldsets = root.querySelectorAll('fieldset[data-index]');
    var counter = root.querySelector('[data-bt-counter]');
    function selected(){ var out = []; fieldsets.forEach(function(fs){ var c = fs.querySelector('input:checked'); out[+fs.dataset.index] = c ? c.value : null; }); return out; }
    function mediaFor(opts){
      var exact = data.find(function(v){ return v.media && v.options.every(function(o,i){ return opts[i] == null || o === opts[i]; }); });
      if(exact) return exact.media;
      var c = fieldsets[0] ? opts[+fieldsets[0].dataset.index] : null;
      var any = data.find(function(v){ return v.media && v.options.indexOf(c) > -1; });
      return any ? any.media : null;
    }
    function show(mediaId){
      var li = gal.querySelector('[data-media="' + mediaId + '"]');
      if(!li) return;
      if(window.innerWidth >= 990){
        if(gal.firstElementChild !== li){ if(!reduce.matches){ li.classList.add('is-swap'); } gal.insertBefore(li, gal.firstElementChild); requestAnimationFrame(function(){ li.classList.remove('is-swap'); }); }
        var top = gal.getBoundingClientRect().top;
        if(top < 0 || top > window.innerHeight * 0.6){ window.scrollTo({ top: window.scrollY + top - 90, behavior: reduce.matches ? 'auto' : 'smooth' }); }
      } else {
        gal.scrollTo({ left: li.offsetLeft, behavior: reduce.matches ? 'auto' : 'smooth' });
        if(counter){ counter.textContent = (Array.prototype.indexOf.call(gal.children, li) + 1) + ' / ' + gal.children.length; }
      }
    }
    fieldsets.forEach(function(fs){ fs.addEventListener('change', function(){ var m = mediaFor(selected()); if(m) show(m); }); });
  });
})();
